import { Icon } from '@smartgift/frontend-toolkit';
import { useTranslation } from 'react-i18next';

import { useCreateTag } from '@hero/services/contact-service/hooks';
import { useNotification } from '@hero/store/hooks';
import { getNameFeatureFormData } from '@hero/utils';
import { getNameRule } from '@hero/validations';

function useAddTagModal() {
  const { t } = useTranslation();
  const { showNotification } = useNotification();
  const { mutateAsync: createTag } = useCreateTag();

  return {
    addTag: () =>
      showNotification({
        header: t('nameYourTag'),
        formData: getNameFeatureFormData({
          label: t('featureName', { featureType: t('tag') })
        }),
        primaryButtonProps: {
          endIcon: 'next',
          children: t('next')
        },
        secondaryButtonProps: { children: t('cancel') },
        notificationImage: <Icon name="tag" size="xxl" />,
        onSubmit: async ({ formValues, validate }) => {
          const isValid = await validate([
            {
              rule: getNameRule(t('tag')),
              value: formValues.name
            }
          ]);

          if (!isValid) return true;

          await createTag(formValues);
        }
      })
  };
}

export { useAddTagModal };
